import { useState } from "react";
import { cn } from "@/lib/cn";

type Faq = { q: string; a: string };

export function FaqList({ items }: { items: Faq[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="divide-y divide-border rounded-3xl border border-border bg-surface-raised">
      {items.map((item, index) => {
        const open = openIndex === index;
        return (
          <div key={item.q} className="px-5 sm:px-6">
            <button
              type="button"
              className="flex min-h-14 w-full items-center justify-between gap-4 py-4 text-left"
              aria-expanded={open}
              onClick={() => setOpenIndex(open ? null : index)}
            >
              <span className="font-display text-base font-semibold tracking-tight text-fg sm:text-lg">
                {item.q}
              </span>
              <span
                aria-hidden
                className={cn(
                  "grid h-8 w-8 shrink-0 place-items-center rounded-full border border-border text-sm text-muted transition",
                  open && "rotate-45 border-teal/40 text-teal-deep",
                )}
              >
                +
              </span>
            </button>
            {open ? (
              <p className="pb-5 text-pretty text-sm leading-relaxed text-muted sm:text-base">
                {item.a}
              </p>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}
